import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 450,
    marginTop: theme.spacing.unit * 8,
  }),
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  signInTextField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
  },
  button: {
    marginTop: theme.spacing.unit * 4,
  },
  signInBtn: {
    marginLeft: 10,
  },
});

class ForgotPassword extends Component {
  state = {
    email: '',
    password: '',
    confirmPassword: '',
    verificationCode: '',
    showEmail: true,
    showCodeVerification: false,
    showNewPasswordForm: false,
    redirectToSignin: false,
  };
  handleClick = event => {
    event.preventDefault();
    this.setState({
      redirectToSignin: true,
    });
  };
  handleSubmitEmail = async event => {
    event.preventDefault();

    try {
      await Auth.forgotPassword(this.state.email.toLowerCase());
      this.setState({
        showEmail: false,
        showCodeVerification: true,
      });
    } catch (error) {
      alert(error.message);
      this.setState({
        showEmail: true,
        showCodeVerification: false,
        showNewPasswordForm: false,
      });
    }
  };
  handleSubmitVerificationCode = event => {
    event.preventDefault();
    this.setState({
      showCodeVerification: false,
      showNewPasswordForm: true,
    });
  };
  handleSubmitNewPassword = async event => {
    event.preventDefault();
    try {
      await Auth.forgotPasswordSubmit(
        this.state.email.toLowerCase(),
        this.state.verificationCode,
        this.state.password
      );
      this.setState({
        redirectToSignin: true,
      });
    } catch (error) {
      alert(error.message);
      this.setState({
        showEmail: true,
        showCodeVerification: false,
        showNewPasswordForm: false,
      });
    }
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  validateEmail = () => {
    return (
      this.state.email.length > 3 &&
      this.state.email.includes('@') &&
      this.state.email.includes('.')
    );
  };
  render() {
    const { classes } = this.props;
    return this.state.redirectToSignin ? (
      <Redirect from="/forgot-password" to="/signin" />
    ) : (
      <Paper className={classes.root} elevation={4}>
        {this.state.showEmail && (
          <form
            onSubmit={this.handleSubmitEmail}
            className={classes.container}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="email"
              label="Email"
              className={classes.signInTextField}
              margin="normal"
              onChange={this.handleChange}
              helperText="Please enter your email. You will receive a verification code in your email to reset your password."
            />
            <Button
              variant="raised"
              color="primary"
              className={classes.button}
              type="submit"
              disabled={!this.validateEmail()}
            >
              Submit
            </Button>
            <Button
              className={`${classes.button} ${classes.signInBtn}`}
              onClick={this.handleClick}
            >
              Back to Sign In
            </Button>
          </form>
        )}
        {this.state.showCodeVerification && (
          <form
            onSubmit={this.handleSubmitVerificationCode}
            className={classes.container}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="verificationCode"
              label="Verification Code"
              className={classes.signInTextField}
              margin="normal"
              onChange={this.handleChange}
              helperText={`Please enter the verification code you recieved on your email - ${
                this.state.email
              }`}
            />
            <Button
              variant="raised"
              color="primary"
              className={classes.button}
              type="submit"
              disabled={!this.validateEmail()}
            >
              Submit
            </Button>
          </form>
        )}
        {this.state.showNewPasswordForm && (
          <form
            onSubmit={this.handleSubmitNewPassword}
            className={classes.container}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="password"
              label="New Password"
              className={classes.signInTextField}
              margin="normal"
              type="password"
              onChange={this.handleChange}
              helperText="Please enter a new password. Password must be atleast 8 characters long and must contain atleast  1 number, 1 uppercase , 1 lowercase and 1 special character(!@#$%^&*). "
            />
            <TextField
              id="confirmPassword"
              label="Confirm Password"
              className={classes.signInTextField}
              type="password"
              margin="normal"
              onChange={this.handleChange}
            />
            <Button
              variant="raised"
              color="primary"
              className={classes.button}
              type="submit"
              disabled={
                !validatePassword(
                  this.state.password,
                  this.state.confirmPassword
                )
              }
            >
              Submit
            </Button>
          </form>
        )}
      </Paper>
    );
  }
}

function validatePassword(pw, confirmPw) {
  const basic = pw === confirmPw;
  const strong = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
  );

  return basic && strong.test(pw);
}

export default withStyles(styles)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js